import { render, staticRenderFns } from "./AnimatedPrice.vue?vue&type=template&id=6ea31bea&scoped=true"
import script from "./AnimatedPrice.vue?vue&type=script&lang=js"
export * from "./AnimatedPrice.vue?vue&type=script&lang=js"
import style0 from "./AnimatedPrice.vue?vue&type=style&index=0&id=6ea31bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea31bea",
  null
  
)

export default component.exports